// Auto-generated translation for ga.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:43:17.271850+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Do shealbhóirí capall",
    title: "Gach rud do do chapall. In aon aip amháin.",
    subtitle: "Bainistigh sláinte, traenáil, pleanáil agus gairmithe ó chomhad amháin soiléir.",
    primaryCTA: {
      label: "Tosaigh saor in aisce",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Próifíl capaill — meáchan, vacsaíniú, EquiCoach, cothú agus traenáil ar aon scáileán amháin",
      caption: "Do chapall, iomlán os do chomhair.",
    },
    problem: "Is dócha go gcoimeádann tú coinní, grianghraif, traenáil, cothú agus sláinte scaipthe ar fud grúpaí WhatsApp, boscaí bróg agus aipeanna éagsúla. Cailleann tú an t-iomlán mar gheall air sin.",
    solution: "Déanann EquiSight comhad digiteach iomlán de do chapall a théann leat i gcónaí.",
    benefits: [
      "Próifíl iomlán capaill do gach capall",
      "Sláinte, gabha crúb, fiaclóir agus fisiteiripeoir in aon áit amháin",
      "Clár ama le meabhrúcháin chliste",
      "Grianghraif, nótaí agus stair gan teorainn",
      "Cúltaca do gach sonra le Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 capall · saor in aisce i gcónaí",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Capaill iolracha + cúltaca",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh le tosú?",
      title: "Tosaigh inniu le do chéad chapall.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Níos mó capall. Níos mó soiléireachta. Níos mó muiníne.",
    subtitle: "Uasghrádaigh go Premium agus bainistigh do chuid capall go léir gan srianta — le hintleacht iomlán EquiCoach.",
    primaryCTA: {
      label: "Tosaigh 14 lá saor in aisce",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Gach praghas",
      href: "/#pricing",
    },
    audience: "D'úinéirí, d'eachaírí spóirt agus do choimeádaithe capall a bhfuil níos mó ná capall amháin acu.",
    features: [
      "Capall gan teorainn a chur leis",
      "Stair iomlán do gach capall",
      "Cúltaca sonraí",
      "Léargais chuimsitheacha EquiCoach",
      "Fógraí cliste agus pleanáil",
      "Sláinte agus traenáil nasctha go hiomlán",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Níos lú ná €0,17 sa lá",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh?",
      title: "Uasghrádaigh go Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Do mharcaigh manège",
    title: "Éirigh níos fearr, fiú gan do chapall féin.",
    subtitle: "Lean do cheachtanna, do chuid traenála agus d'fhorbairt laistigh de EquiSight — ar níos lú ná cupán caife sa mhí do mhamaí nó do dhaideo. Nó uachtar reoite blasta le huachtar coipthe.",
    primaryCTA: {
      label: "Tosaigh le Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Conas a oibríonn sé?",
      href: "#features",
    },
    problem: "Mar mharcach manège, ní bhíonn do chapall féin agat go minic, ach is mian leat fás agus forbhairt a choimeád súil ar do cheachtanna, do spriocanna agus na capaill a mbíonn tú ag marcaíocht orthu.",
    solution: "Tá feidhmiúlacht manège san áireamh go caighdeánach in Premium — lean d'fhorbairt féin agus féach ar chapaill nasctha an manège ar bhealach léamh-amháin.",
    features: [
      "Traenálacha a rianú",
      "Spriocanna a shocrú",
      "Dul chun cinn a leanúint",
      "Capaill manège a fheiceáil le hainm agus grianghraf",
      "Gan rochtain ar shonraí sláinte príobháideacha",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "In aghaidh na míosa · feidhmiúlacht manège san áireamh",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bí i do bhall",
      title: "Tosaigh mar mharcach manège.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Do mhaneisí & stáblaí",
    title: "Déan do mhaneise inrochtana go digiteach do gach marcach.",
    subtitle: "Tabhair ceangal do mharcaigh le capaill, ceachtanna agus dul chun cinn — gan sonraí íogaire stábla a roinnt.",
    primaryCTA: {
      label: "Iarr rochtain",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar mhodúil",
      href: "#features",
    },
    audience: "Cabhraíonn EquiSight le maneisí agus stáblaí marcaigh a choinneáil níos mó rannpháirteach agus iad féin a idirdhealú go digiteach.",
    features: [
      "Capaill mhaneise a dhéanamh infheicthe do mharcaigh",
      "Ainm agus grianghraf do gach capall",
      "Marcaigh a nascadh le capaill",
      "Rochtain léamh amháin ar shonraí príobháideacha",
      "Stair ceachtanna agus traenála go lárnach",
      "Bainistíocht úsáideoirí le róil",
    ],
    benefits: [
      "Níos mó ceangail le marcaigh",
      "Cuma níos gairmiúla",
      "Seirbhís dhigiteach bhreise do bhaill",
      "Sruth ioncaim nua trí úsáid feidhlime",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "In aghaidh na míosa · feidhmiúlacht mhaneise san áireamh do mharcaigh",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh?",
      title: "Gníomhachtaigh Modúl Maneise.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Modúl pórúcháin",
    title: "Smacht ar thimthriall, toircheas agus forbairt searrach.",
    subtitle: "An modúl pórúcháin iomlán do shealbhóirí láracha agus póraitheoirí — ó chlúdach go searrach, in amlíne amháin.",
    primaryCTA: {
      label: "Gníomhachtaigh Modúl Pórúcháin",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar ghnéithe",
      href: "#features",
    },
    audience: "Do phóraitheoirí, sealbhóirí láracha agus stáblaí a bhainistíonn láracha iolracha.",
    features: [
      "Rianú timthrialla",
      "Eas-théamh a chlárú",
      "Sonraí insiminithe a thaifeadadh",
      "Cuntóir siar chuig éiceo-scannáin",
      "Seiceálacha toirchis a phleanáil",
      "Crann ginealais agus sinsearacht",
      "Forbairt searrach",
      "Forbhreathnú ar gach láir thoircheasach",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "In aghaidh na míosa · Modúl pórúcháin san áireamh in Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Tosaigh inniu",
      title: "Tosaigh le bainistíocht pórúcháin.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Modúl Gabha Capall",
    title: "Oibrigh níos cliste mar ghabha capall. Taifeaد gach rud go gairmiúil.",
    subtitle: "Clár ama, grianghraif, nótaí agus stair cóireála in aon mhodúl amháin — níos lú míchumarsáide, comhad níos láidre.",
    primaryCTA: {
      label: "Tosaigh mar ghabha capall",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar an mBeart Professional",
      href: "/professional",
    },
    audience: "Do ghabha capall atá ag iarraidh forbhreathnú, cruthúnas agus cumarsáid le custaiméirí a fheabhsú.",
    features: [
      "Clár ama pearsanta",
      "Coinní in aghaidh an chustaiméara",
      "Próifílí capall a fheiceáil",
      "Grianghraif roimh agus ina dhiaidh a chur leis",
      "Cóireáil a thaifeadadh",
      "Comhairle agus nótaí a thaifeadadh",
      "Fógra ETA chuig custaiméir: \"Tá an gabha capall ar an mbealach\"",
    ],
    benefits: [
      "Oibriú níos gairmiúla",
      "Níos lú míchumarsáide",
      "Tógáil comhaid níos fearr",
      "Níos láidre maidir le dliteanas",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "In aghaidh na míosa · Modúl Gabha Capall san áireamh in Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh?",
      title: "Gníomhachtaigh Modúl Gabha Capall.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Modúl fiaclóra",
    title: "Comhad fiaclóireachta iomlán do gach capall.",
    subtitle: "Cláraigh torthaí, cóireálacha agus leantacht go díreach in EquiSight.",
    primaryCTA: {
      label: "Tosaigh mar fhiaclóir capall",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar an mBeart Professional",
      href: "/professional",
    },
    audience: "Fiaclóirí capall, tréidlianna agus cleachtais ar mian leo oibriú ar bhealach struchtúrtha.",
    features: [
      "Seiceáil cheirde a chlárú",
      "Torthaí in aghaidh gach cóireála",
      "Grianghraif a chur leis",
      "Tuarascáil don úinéir",
      "Comhairle leantachta",
      "Stair in aghaidh gach capaill",
      "Coinne nua a phleanáil",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "In aghaidh na míosa · Modúl fiaclóra san áireamh sa Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh?",
      title: "Gníomhachtaigh an Modúl Fiaclóra.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Modúl Fisiteiripe / Ostea",
    title: "Lean súil ar chorp, gluaiseacht agus téarnamh ar bhealach gairmiúil.",
    subtitle: "D'fhisiteiripeoirí agus d'oistéapataigh ar mian leo capaill a thionlacan go struchtúrach.",
    primaryCTA: {
      label: "Tosaigh mar fhisiteiripeoir/oistéapaí",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar an mBeart Gairmiúil",
      href: "/professional",
    },
    features: [
      "Iontógáil in aghaidh an chapaill",
      "Torthaí coirp a chlárú",
      "Grianghraif agus físeáin a chur leis",
      "Tuarascáil chóireála a chruthú",
      "Cleachtaí agus leantacht a roinnt",
      "Conair téarnaimh a leanúint",
      "Stair in aghaidh an chapaill",
    ],
    benefits: [
      "Léargas níos fearr thar am",
      "Tuairisciú gairmiúil",
      "Cumarsáid shoiléir le húinéir, traenálaí agus marcach",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "In aghaidh na míosa · Modúl Fisiteiripe / Ostea san áireamh sa Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh?",
      title: "Gníomhachtaigh Modúl Fisiteiripe / Ostea.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Modúl Traenála",
    title: "Coitseáil marcaigh le sonraí, spriocanna agus dul chun cinn.",
    subtitle: "Déan traenáil intomhaiste agus treoir níos gairmiúla — do mharcach amháin nó níos mó.",
    primaryCTA: {
      label: "Tosaigh mar traenálaí",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar pháiste Pro",
      href: "/#pricing",
    },
    audience: "Do theagascóirí, traenálaithe agus cóitseálaithe le marcaigh nó capaill iolracha.",
    features: [
      "Marcaigh a nascadh",
      "Capaill a rianú",
      "Spriocanna traenála a shocrú",
      "Aiseolas a thabhairt",
      "Torthaí comórtais a anailísiú",
      "Dul chun cinn in aghaidh gach cumasc a fheiceáil",
      "Anailísí prótacail a úsáid le haghaidh fócas traenála",
    ],
    benefits: [
      "Treoir níos fearr",
      "Níos mó struchtúir",
      "Cumarsáid níos gairmiúla",
      "Nasc níos láidre le custaiméirí",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "In aghaidh na míosa · Modúl Traenála san áireamh in Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh?",
      title: "Gníomhachtaigh an Modúl Traenála.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Anailís Comórtais",
    title: "Ón prótacal go feabhas feidhmíochta.",
    subtitle: "Uaslódáil do phrótacal comórtais agus faigh amach cá bhfuil tú ag cailleadh pointí — ní hamháin d'fhéachaint ar do scór, ach tuiscint a fháil ar conas dul chun cinn.",
    primaryCTA: {
      label: "Anailísigh do chéad phrótacal",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar Premium",
      href: "/premium",
    },
    features: [
      "Grianghraf prótacail a uaslódáil",
      "Próiseáil tosaigh agus cúil",
      "Aicme, uimhir trialacha agus giúróir a aithint",
      "Scóir in aghaidh an chomhpháirt a anailísiú",
      "Tuairimí a achoimriú",
      "Láidreachtaí agus laigí a thaispeáint",
      "Treochtaí in aghaidh teaglaim each-marcach",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "In aghaidh na míosa · anailís comórtais san áireamh ó Premium ar aghaidh",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh?",
      title: "Tosaigh le hanailís comórtais.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Beart Gairmiúil",
    title: "Do ghairmithe timpeall an chapaill.",
    subtitle: "Gabha, fiaclóir, fisiteiripeoir, oistéapat nó traenálaí: oibrigh le chéile in aon chomhad digiteach capaill amháin.",
    primaryCTA: {
      label: "Tosaigh mar ghairmiúil",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Féach ar mhodúil ar leith",
      href: "#features",
    },
    audience: "Comhcheanglaíonn an Beart Gairmiúil gach modúl speisialtachta in aon síntiús amháin.",
    features: [
      "Modúl Gabha",
      "Modúl Fiaclóra",
      "Modúl Fisiteiripe / Oistéapait",
      "Clár & bainistíocht cliant",
      "Próifílí capall & tuarascálacha",
      "Stair cóireála & tógáil comhaid",
      "Cumarsáid leis an úinéir",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "In aghaidh na míosa · gach modúl speisialtachta san áireamh",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Réidh?",
      title: "Roghnaigh Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Uimhreacha éigeandála capaill",
    title: "An cabhair cheart i gcónaí ar do mhéar.",
    subtitle: "In am éigeandála, tá gach soicind luachmhar. Le EquiSight, tá sonraí teagmhála tábhachtacha do chapaill ar fáil láithreach agat — buail buaic amháin agus cuir glao.",
    primaryCTA: {
      label: "Ullmhaigh do theagmhálaithe éigeandála",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Tosaigh saor in aisce le EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Teagmhálaithe éigeandála — glaoigh, seol WhatsApp nó nascleanúint díreach chuig tréidlia, clinic agus gabha capall",
      caption: "Buaic amháin. Gan scaoll cuardaigh.",
      embeddedFrame: true,
    },
    problem: "Tá rud éigin ar do chapall — colic, gortú, scaoll. Agus ansin tosaíonn an cuardach. Cé a ghlaofaidh tú? An bhfuil an uimhir cheart agat? An uimhir éigeandála í seo? Cailltear am luachmhar.",
    solution: "Le EquiSight, tá gach rud ar fáil díreach agat. Gan cuardach. Gan amhras. Buaic amháin agus tá tú i dteagmháil.",
    scenario: {
      title: "Samhlaigh — tá comharthaí colic ar do chapall.",
      steps: [
        "Osclaíonn tú EquiSight",
        "Cliceálann tú ar \"Tréidlia\"",
        "Cuireann tú glao díreach",
      ],
      tagline: "Gan strus. Gan cuardach. Gníomh amháin.",
    },
    features: [
      "Gach uimhir éigeandála in aon áit amháin",
      "Glao le buaic amháin ón aip",
      "WhatsApp le buaic amháin",
      "Nascleanúint díreach chuig an seoladh",
      "Liosta teagmhálaithe ar leith do gach capall",
      "Tréidlia, clinic, gabha capall, fiaclóir, fisiteiripeoir",
      "Seoladh agus treoracha bealaigh ar fáil láithreach",
      "Marcáil uimhreacha is fearr leat le réalta",
      "Uimhreacha éigeandála (112, 144) ar bharr i gcónaí",
    ],
    benefits: [
      "Suaimhneas agus smacht i gcás éigeandála",
      "Tá na huimhreacha céanna ag gach duine sa stábla",
      "Ná déan dearmad ar chártaí gnó a thuilleadh",
      "Freagair soicindí níos tapúla i gcás práinne",
    ],
    audience: "Do úinéirí capall, cúramóirí, traenálaithe agus stáblaí — gach duine atá freagrach as capall.",
    showcase: {
      eyebrow: "Réidh do shocrú roimh ré",
      title: "13 catagóir teagmhálaithe — réidh le líonadh isteach.",
      description: "Ó thréidlia agus clinic éigeandála go dtí déantóir diallait, teagascóir agus bainisteoir féaraigh. Tuigeann EquiSight do dhomhan agus ullmhaíonn sé na réimsí teagmhála cearta duit. Buail, líon isteach, réidh.",
      bullets: [
        "Éigeandáil & sláinte — tréidlia, éigeandáil, clinic, líne nimhithe",
        "Cúram laethúil — gabha capall, fiaclóir, fisiteiripeoir, teagascóir",
        "Stábla & féarach — sealbhóir stábla, bainisteoir féaraigh, stábla lóistín",
        "Beathú & ábhair — soláthróirí féir, beatha thiubhaithe, tuí",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Scáileán bainistíochta teagmhálaithe éigeandála — gach teagmhálaí molta de réir catagóire",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Seicliosta uimhreacha éigeandála capaill",
      items: [
        "Tréidlia",
        "Clinic éigeandála (24/7)",
        "Otharcharr ainmhithe · 144",
        "Gabha capall",
        "Teagmhálaí cúltaca",
        "Uimhir éigeandála ghinearálta · 112",
      ],
      cta: {
        label: "Oscail in EquiSight agus líon isteach láithreach",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Uimhreacha éigeandála",
          price: "Gratis",
          note: "Saor in aisce i gcónaí · do chách, i ngach síntiús",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bí ullamh roimh ré",
      title: "Sula mbíonn sé de dhíth.",
      href: "/#waitlist",
    },
    microcopy: [
      "Gan oibleagáidí",
      "Socraithe laistigh de 2 nóiméad",
      "Inathraithe i gcónaí",
    ],
  },
};

export default LANDINGS;
